"use strict";
import Browser from './../util/browser';

class Kentei{
	constructor($con){
		this.$con = $con;
		
		this.$opening = this.$con.find('.opening');
		this.$main = this.$con.find('.main');
		this.$question = this.$con.find('.question');
		this.$result = this.$con.find('.result');
		this.$btn_start = this.$con.find('.btn_start');
		this.$btn_return = this.$con.find('.btn_return');
		this.$items = this.$con.find('.question').find('.item');

		this.init();		
	}
	
	init(){
		this.seikaiCount = 0;
		this.currentIndex = 0;
		this.$opening.show();
		this.$main.hide().css({opacity:0});
		this.$question.hide().css({opacity:0});
		this.$result.hide().css({opacity:0});
		
		this.$btn_start.on('click',this.start.bind(this));
		this.$btn_return.on('click',this.back.bind(this));
	}
	
	start(){
		this.$opening.velocity('stop').velocity({opacity:0},{duration:300,display:'none'});
		this.$main.velocity('stop').velocity({opacity:1},{duration:300,display:'block',delay:200});
		this.$question.velocity('stop').velocity({opacity:1},{duration:300,display:'block',delay:200});

		setTimeout(()=>{
			this.show();
		},300);
	}
	
	show(){
		let $item = this.$items.eq(this.currentIndex);
		$item.velocity('stop').velocity({opacity:1,translateY:[0,10]},{duration:500,display:'block'});
		$item.find('.a').on('click',this.answer.bind(this));
	}
	
	answer(e){
		let $answer = $(e.currentTarget);
		let $item = this.$items.eq(this.currentIndex);
		
		if($answer.data('r') == '1'){
			this.seikaiCount++;
		}
		
		this.hide();
	}
	
	hide(){
		let $item = this.$items.eq(this.currentIndex);
		$item.velocity('stop').velocity({opacity:0,translateY:-10},{duration:300,display:'none'});
		$item.find('.a').off();
		
		setTimeout(()=>{
			this.next();
		},300);
	}

	next(){
		this.currentIndex++;
		if(this.currentIndex >= this.$items.length ){
			this.result();			
		} else{
			this.show();
		}
	}
	
	result(){
		this.$result.find('.t1').text(this.seikaiCount);
		this.$result.velocity('stop').velocity({opacity:1},{duration:300,display:'block',delay:200});
		this.$result.find('.yukimaru').velocity('stop')
		.velocity({translateY:20},{duration:1,delay:0})
		.velocity({translateY:0},{duration:800});
		
		this.$result.find('h3').velocity('stop')
		.velocity({translateX:-20},{duration:1,delay:0})
		.velocity({translateX:[0,-20]},{duration:800,delay:201});
		
		this.$result.find('.tensu').velocity('stop')
		.velocity({translateX:20},{duration:1,delay:0})
		.velocity({translateX:[0,20]},{duration:800,delay:201});		
	}
	
	back(){
		this.$result.velocity('stop').velocity({opacity:0},{duration:300,display:'none'});
		this.$main.velocity('stop').velocity({opacity:0},{duration:300,display:'none'});
		this.$opening.velocity('stop').velocity({opacity:1},{duration:300,display:'block',delay:300});
		
		this.seikaiCount = 0;
		this.currentIndex = 0;
	}
}

export default Kentei;


// WEBPACK FOOTER //
// ./js/parts/kentei.js